import { render, staticRenderFns } from "./ZCopyId.vue?vue&type=template&id=453c981a&"
import script from "./ZCopyId.vue?vue&type=script&lang=ts&"
export * from "./ZCopyId.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports